import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import { toFormData } from "helpers/formUtils";
import branchesService from "services/admin/branchesService";

interface BranchFormProps {
  router: any;
  data: any;
}

const BranchForm = ({ router, data }: BranchFormProps) => {
  const {
    navigate,
    params: { id },
  } = router;
  const { branch } = data;

  const fieldsWithData = [
    {
      key: "name",
      label: "Название филиала",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "code",
      label: "Код филиала",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "address",
      label: "Адрес",
      inputType: inputTypeEnum.text,
    },
    {
      key: "latitude",
      label: "Широта (latitude)",
      inputType: inputTypeEnum.text,
    },
    {
      key: "longitude",
      label: "Долгота (longitude)",
      inputType: inputTypeEnum.text,
    },
  ];

  const onSubmit = async (formValues: any) => {
    try {
      if (branch) {
        await branchesService.put(id, formValues);
        snack("Филиал обновлен успешно!");
      } else {
        await branchesService.post(formValues);
        snack("Филиал создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={branch ? "Редактирование филиала" : "Создание филиала"}>
      <AppForm onSubmit={onSubmit} data={branch} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(BranchForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["branch"] = () => branchesService.get(router.params.id);
    }
    return useLoadAll(requests);
  }),
);
